<template>
    <section class="documentation">

        <TheHeader ref="header"/>
        <!--<div class="hero is-primary">
            <div class="hero-body hero-lite ">
                <div class="container">-->
                    <!--<p class="title">{{ title }}</p>-->
                    <!--<p class="subtitle is-hidden-touch">{{ subtitle }}</p>-->
                 <!--   <img src="../../statics/img/CERTICOMBLANCO.png" height="110" width="210"/>
                </div>
            </div>
        </div>-->

        <main class="main">

            <router-view/>
        </main>

        <TheFooter/>
    </section>
</template>

<script>
    import TheHeader from './TheHeader'
    import TheFooter from './TheFooter'

    export default {
        components: {
            TheHeader,
            TheFooter
        },
        data(){
          return{
            title: 'CERTICOM',
            subtitle: 'Intranet',
          }
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/DefaultTemplate.vue